module.exports = __webpack_public_path__ + "static/media/un-employment-group-user.71503183.svg";